<template lang="pug">
ResourceMetadataEditor(:key="resourceId" v-bind="resourceProps")
</template>

<script setup lang="ts">
import ResourceMetadataEditor from './ResourceMetadataEditor.vue';
import { computed } from 'vue';
import { useRoute } from 'vue-router';

const route = useRoute();

const resourceId = computed(() => {
  const fileName = route.params.fileName as string;
  const parts = fileName.split('_');
  return Number(parts[parts.length - 1]);
});

const firmCode = computed(() => {
  const fileName = route.params.fileName as string;
  const parts = fileName.split('_');
  return parts.length > 1 ? parts.slice(0, -1).join('_') : undefined;
});

// productType is now optional - can be derived from resource data if not provided
const productType = computed(() => {
  const type = route.query.productType as string;
  if (
    type &&
    ['video', 'webinar', 'guide', 'template', 'blog', 'playlist'].includes(type)
  ) {
    return type as
      | 'video'
      | 'webinar'
      | 'guide'
      | 'template'
      | 'blog'
      | 'playlist';
  }
  // If not provided in query, return undefined - ResourceMetadataEditor will derive it from resource data
  return undefined;
});

const resourceProps = computed(() => ({
  resourceId: resourceId.value,
  firmCode: firmCode.value,
  productType: productType.value
}));
</script>
